



import {Component, Vue} from 'vue-property-decorator';

import TextInput from "@/components/Atoms/TextInput/TextInput.vue";
import TextInputGroup from "@/components/Molecules/TextInputGroup/TextInputGroup.vue";

import RecentSearch from "@/components/Molecules/RecentSearch/RecentSearch.vue";
import {ServiceFactory} from "@/services";
import {RecentSearchDto, RecentSearchModel} from "@/share";
import {getModule} from "vuex-module-decorators";
import {User} from "@/store/user";
import {BABY} from "@/constants";

const RecentSearchService = ServiceFactory.get('recentSearch')
@Component({
  components: {TextInput, TextInputGroup, RecentSearch}
})
export default class SearchInput extends Vue {
  private isLoading = false
  private isRecentSearchLoading = false
  private keyword = '';
  private items: RecentSearchModel[] = []
  private hasOverlay = true

  created() {
    this.getRecentSearch()
  }

  private mounted() {
    this.hasOverlay = false
  }

  private get loadingClass(): string {
    if (this.isLoading) return 'invisible'
    return ''
  }

  private async getRecentSearch(): Promise<void> {
    this.isLoading = true
    this.items = await RecentSearchService.list().catch(() => [])
    this.isLoading = false
  }

  private async deleteItemSearchRecent(id: number): Promise<void> {
    const response = await RecentSearchService.delete(id).catch(() => false)
    if (response.hasError) return // TODO handler error
    return this.getRecentSearch()
  }

  private async onClickSearchRecent(id: number): Promise<any> {
    const response = await RecentSearchService.update(id).catch(() => new RecentSearchModel({}))
    if (response.hasError) return // TODO handler error
    const babyId = this.getCurrentBaby()
    const keyword = response.content

    return this.$router.push({name: 'routes.search.result', query: {keyword: keyword}, params: {id: babyId}})
  }

  private async handleRecentSearch(): Promise<any> {
    if (!this.keyword || this.isLoading || this.isRecentSearchLoading) return
    const payload: RecentSearchDto = new RecentSearchDto({
      content: this.keyword
    })
    this.isRecentSearchLoading = true
    const response = await RecentSearchService.create(payload).catch(() => new RecentSearchModel({}))
    this.isRecentSearchLoading = false
    if (response.hasError) return // TODO handler error

    const babyId = this.getCurrentBaby()
    return this.$router.push({
      name: 'routes.search.result',
      query: {keyword: this.keyword},
      params: {id: babyId}
    })
  }

  private getCurrentBaby(): any {
    const UserModule = getModule(User, this.$store);
    let babyId = UserModule.currentBaby
    if (!babyId) babyId = localStorage.getItem(BABY.SELECTED) || ''

    return babyId
  }

  private changeKeyword(value: string) {
    this.keyword = value
  }
}
